(function () {
  'use strict';
  function quote(variant, rawQuantity) {
    var parsed = Number(rawQuantity);
    var quantity = Number.isFinite(parsed) ? Math.max(1, Math.floor(parsed)) : 1;
    var tier = quantity >= 7 ? 7 : quantity >= 5 ? 5 : quantity >= 3 ? 3 : 1;
    var percent = tier === 7 ? 75 : tier === 5 ? 65 : tier === 3 ? 55 : 0;
    var current = Math.max(0, Number(variant.price) || 0);
    var reference = Number(variant.compare) > 0 ? Number(variant.compare) : 0;
    var unit = current;
    if (percent && reference) unit = Math.round(reference * (100 - percent) / 100);
    return { quantity: quantity, tier: tier, unit: Math.round(unit), total: Math.round(unit) * quantity, reference: reference, percent: reference ? Math.round((1 - unit / reference) * 100) : 0 };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { quote: quote };
  if (typeof document === 'undefined') return;

  function initialize(root) {
    if (root.dataset.offerReady) return;
    var product = root.closest('[data-product]');
    var form = product && product.querySelector('form[data-cart-form]');
    var quantityInput = form && form.querySelector('[name="quantity"]');
    var variants;
    try { variants = JSON.parse(root.querySelector('[data-offer-variants]').textContent); } catch (_) { return; }
    if (!product || !form || !quantityInput || !variants.length) return;
    root.dataset.offerReady = 'true';
    var currency = root.dataset.currency || 'RON';
    var format = new Intl.NumberFormat('ro-RO', { style: 'currency', currency: currency });
    var buttons = Array.from(root.querySelectorAll('[data-offer-quantity]'));
    var message = root.querySelector('[data-offer-message]');
    function money(cents) { return format.formatToParts(cents / 100).map(function (part) { return part.type === 'currency' && currency === 'RON' ? 'lei' : part.value; }).join(''); }
    function currentVariant() {
      var controls = Array.from(product.querySelectorAll('[data-option-index]'));
      var chosen = controls.map(function (control) {
        if (control.tagName === 'SELECT') return control.value;
        var checked = control.querySelector('input:checked');
        return checked ? checked.value : '';
      });
      if (chosen.length) return variants.find(function (variant) { return variant.options.every(function (value, index) { return value === chosen[index]; }); });
      var input = form.querySelector('[data-variant-id]');
      return variants.find(function (variant) { return String(variant.id) === String(input && input.value); }) || variants[0];
    }
    function render() {
      var variant = currentVariant();
      var result = quote(variant || {}, quantityInput.value);
      buttons.forEach(function (button) {
        var amount = quote(variant || {}, button.dataset.offerQuantity);
        button.disabled = !variant || !variant.available || (!amount.reference && amount.tier > 1);
        button.setAttribute('aria-pressed', String(Number(button.dataset.offerQuantity) === result.tier));
        button.querySelector('[data-offer-price]').textContent = variant ? money(amount.unit) : '—';
        button.querySelector('[data-offer-discount]').textContent = amount.percent ? '−' + amount.percent + '%' : 'Prețul actual';
      });
      root.querySelector('[data-offer-total]').textContent = variant ? result.quantity + (result.quantity === 1 ? ' set' : ' seturi') + ' · Total ' + money(result.total) : 'Selectează o variantă disponibilă.';
      if (!variant) return;
      // Use the existing theme's price markup, including its sticky buy bar.
      product.querySelectorAll('[data-price]').forEach(function (node) {
        node.replaceChildren();
        if (result.reference > result.unit) {
          var price = document.createElement('span');
          price.className = 'product__price-sale';
          price.textContent = money(result.unit);
          var compare = document.createElement('s');
          compare.className = 'product__price-compare';
          compare.textContent = money(result.reference);
          node.append(price, document.createTextNode(' '), compare);
        } else node.textContent = money(result.unit);
      });
      var summary = product.querySelector('[data-sale-summary]');
      if (summary) {
        summary.hidden = result.reference <= result.unit;
        var percentage = summary.querySelector('[data-discount-percent]');
        var saving = summary.querySelector('[data-discount-saving]');
        if (percentage) percentage.textContent = '−' + result.percent + '%';
        if (saving) saving.textContent = money(Math.max(0, result.reference - result.unit));
      }
    }
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        quantityInput.value = button.dataset.offerQuantity;
        message.hidden = true;
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        render();
      });
    });
    product.addEventListener('input', function (event) { if (event.target === quantityInput) render(); });
    product.addEventListener('change', function () {
      message.hidden = true;
      // Theme variant selection runs on document.change; refresh after it.
      window.setTimeout(render, 0);
    });
    if (root.dataset.preview === 'true') {
      form.addEventListener('submit', function (event) {
        if (quote(currentVariant() || {}, quantityInput.value).tier < 3) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        message.textContent = 'Aceasta este o previzualizare. Reducerea de cantitate trebuie activată înainte de adăugarea ofertei în coș.';
        message.hidden = false;
      }, true);
    }
    render();
  }
  function boot(scope) { scope.querySelectorAll('[data-kruidvat-offer]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
